(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.fr = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      autocomplete: {
        noDataMessage: 'Aucune donnée trouvée'
      },
      combobox: {
        placeholder: 'Sélectionner',
        searchPlaceholder: 'Recherche'
      },
      datepicker: {
        apply: 'Appliquer',
        clearSelection: 'Effacer',
        pickADays: 'Sélectionner les jours',
        prevYear: 'Année précédente',
        nextYear: 'Année suivante',
        prevMonth: 'Mois précédent',
        nextMonth: 'Mois suivant',
        year: '',
        month1: 'Janvier',
        month2: 'Février',
        month3: 'Mars',
        month4: 'Avril',
        month5: 'Mai',
        month6: 'Juin',
        month7: 'Juillet',
        month8: 'Août',
        month9: 'Septembre',
        month10: 'Octobre',
        month11: 'Novembre',
        month12: 'Décembre',
        weeks: {
          sun: 'Dim',
          mon: 'Lun',
          tue: 'Mar',
          wed: 'Mer',
          thu: 'Jeu',
          fri: 'Ven',
          sat: 'Sam'
        },
        months: {
          jan: 'Jan.',
          feb: 'Fév.',
          mar: 'Mar.',
          apr: 'Avr.',
          may: 'Mai',
          jun: 'Juin',
          jul: 'Juil.',
          aug: 'Août',
          sep: 'Sept.',
          oct: 'Oct.',
          nov: 'Nov.',
          dec: 'Déc.'
        },
        pickADay: 'Sélectionnez un jour'
      },
      timepicker: {
        meridiemAM: 'AM',
        meridiemPM: 'PM'
      },
      dropdown: {
        noDataMessage: 'Aucune donnée trouvée'
      },
      filepicker: {
        browse: 'Parcourir',
        select: 'Sélectionner un fichier'
      },
      filter: {
        apply: 'Appliquer',
        cancel: 'Annuler',
        filterButton: 'Filtrer',
        reset: 'Réinitialiser les filtres',
        resetDefault: 'Réinitialiser au défaut'
      },
      search: {
        noDataMessage: 'Aucune donnée trouvée'
      },
      'multi-search': {
        'separator-and': 'ET',
        'search-button': 'Recherche',
        'search-placeholder': 'Rechercher par nom'
      },
      select: {
        all: 'Tout',
        clearSelection: 'Supprimer la sélection',
        noMatch: 'Aucune donnée trouvée',
        noData: 'Aucune donnée',
        placeholder: 'Sélectionner',
        item: 'élément(s)',
        selected: 'sélectionné',
        found: 'trouvé'
      },
      upload: {
        browseButton: 'Parcourir',
        text: 'Glissez et déposez les fichiers à transférer, ou cliquez sur « Parcourir »',
        tip: 'Vous pouvez télécharger 10 fichiers pesant jusqu\'à 25 Mo chacun'
      },
      table: {
        emptyText: 'Aucune donnée'
      },
      tree: {
        emptyText: 'Aucune donnée'
      }
    }
  };
  _exports.default = _default;
});